import { FaIcon, MDBadge, MDButton, MDTypography } from '@components';
import { IconButton, Tooltip } from '@mui/material';

const NavbarMenuItem = ({
  icon,
  iconLabel,
  onNavbarItemClick,
  messageCount = 0,
  islink,
  color,
  toolTipText
}: any) => {
  const hideLabel =
    iconLabel === 'MSG' || iconLabel === 'LOGOUT' || iconLabel === 'HELP';

  return (
    <Tooltip
      title={toolTipText}
    >
      <MDButton
        onClick={onNavbarItemClick}
        border='none'
        sx={{
          paddingX: '12px',
          minWidth: 0,
          color: color,
          ':hover': {
            color: color
          }
        }}
        circular={false}
      >
        {iconLabel === 'MSG' ? (
          <MDBadge
            badgeContent={messageCount}
            color='error'
            size='xs'
            sx={{
              '& .MuiBadge-badge': {
                marginTop: '-8px',
                marginRight: '-5px',
                borderRadius: '1rem'
              }
            }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            <FaIcon
              icon={icon}
              typographyProps={{
                color: color,
                variant: 'xs'
              }}
            />
          </MDBadge>
        ) : islink ? (
          <IconButton
            href={islink}
            target='_blank'
            sx={{ padding: '0px !important', margin: '0px !important' }}
          >
            <FaIcon
              icon={icon}
              typographyProps={{
                color: color,
                variant: 'xs'
              }}
            />
          </IconButton>
        ) : (
          <FaIcon
            icon={icon}
            typographyProps={{
              color: color,
              variant: 'xs'
            }}
          />
        )}

        {!hideLabel && (
          <MDTypography
            variant='xs'
            color='info'
            fontWeight='intermediate'
            ml='4px'
            mb='2px'
          >
            {iconLabel}
          </MDTypography>
        )}
      </MDButton>
    </Tooltip>
  );
};

export default NavbarMenuItem;
